import React from 'react';
import {isServer} from "../utils/utils";

export default function useMoengageLoad(): [boolean] {
  const [isLoaded, setIsLoaded] = React.useState(false);

  function checkAndSet() {
    // @ts-ignore
    if (global.Moengage) {
      setIsLoaded(true);
    } else {
      const timeout = setTimeout(() => {
        clearTimeout(timeout);
        checkAndSet();
      }, 800);
    }
  }

  React.useEffect(() => {
    if (!isServer()) {
      checkAndSet();
    }
  }, []);

  return [isLoaded];
}
